import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PosPromoOtoPage } from './pos-promo-oto.page';

const routes: Routes = [
  {
    path: '',
    component: PosPromoOtoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PosPromoOtoPageRoutingModule {}
